import React from 'react';
import {
  TextInput,
  Filter,
  ReferenceInput,
  AutocompleteInput,
} from 'react-admin';

export const TerminalFilter = (props) => (
  <Filter filters={terminalFilters} {...props} />
);

export const terminalFilters = [
  <TextInput source="alias" label="Search by alias" alwaysOn />,
  <ReferenceInput
    source="submerchantID"
    reference="SubMerchant"
    label="Submerchant"
  >
    <AutocompleteInput
      optionText="name"
      parse={(value) => (value === '' ? 0 : value)}
      source="submerchantID"
      fullWidth
      disableClearable
      variant="outlined"
      label="Submerchant"
      sx={{ width: '220px' }}
    />
  </ReferenceInput>,
];
